import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import he from 'he';

import siteData from '../services/siteData';
import api, { urlParamCharacter } from '../services/api';
import CategoriesLayout from '../layouts/CategoriesLayout';
import Slideshow from '../components/Slideshow';
import Thumbnail from '../components/Thumbnail';
import FetcherButton from '../components/FetcherButton';

const NUM_LOCATIONS = 4;

export default class LocationsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      locations: Array.from(Array(NUM_LOCATIONS).keys()),
      previousPage: 0,
      totalPages: 1,
      title: '',
      isLoading: true,
    };
    this.getLocations = this.getLocations.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  componentDidMount() {
    this.getLocations();
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params.slug !== match.params.slug) {
      this.getLocations();
    }
  }

  getLocations(page = 1) {
    const { match, history } = this.props;
    const { previousPage } = this.state;

    if (page === 1) {
      this.setState({ locations: Array.from(Array(NUM_LOCATIONS).keys()) });
    }

    this.setState({ isLoading: true });

    api.get(`/locations${urlParamCharacter}category=${match.params.slug}&orderby=menu_order&order=asc`)
      .then((response) => {
        if (page > 1) {
          this.setState((prevState) => ({
            locations: [...prevState.locations, ...response.data],
          }));
        } else {
          this.setState({ locations: response.data });
        }

        this.setState({
          previousPage: previousPage + 1,
          totalPages: parseInt(response.headers['x-wp-totalpages'], 10),
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });

    this.getTitle();
  }

  getTitle() {
    const { match } = this.props;

    api.get(`locations_categories${urlParamCharacter}slug=${match.params.slug}`)
      .then((response) => {
        this.setState({
          title: response.data[0].title.rendered,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  render() {
    const { match } = this.props;
    const {
      locations,
      previousPage,
      totalPages,
      title,
      isLoading,
    } = this.state;

    return (
      <CategoriesLayout
        path="/locations"
        header={<Slideshow />}
      >
        <Helmet>
          <title>{`${title ? `${he.decode(title)} - ` : ''}${siteData.title}`}</title>
        </Helmet>
        <div className="container">
          <h1 className="sr-only">{title}</h1>
          <div className="columns">
            {locations.map((location, i) => (
              <Thumbnail
                key={location.slug || i}
                slug={`locations/${match.params.slug}/${location.slug || ''}`}
                title={location.title && location.title.rendered}
                imageUrl={location.acf && location.acf.image.url}
                imageAlt={location.acf && location.acf.image.alt}
                isLoading={isLoading}
              />
            ))}
          </div>
          <FetcherButton
            isLoading={isLoading}
            previousPage={previousPage}
            totalPages={totalPages}
            getItems={this.getLocations}
          />
        </div>
      </CategoriesLayout>
    );
  }
}

LocationsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

LocationsPage.defaultProps = {
  match: { params: { slug: '' } },
};
